module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_L-2538.f4da535c.png";